import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

// Pages
import Dashboard from "./pages/Dashboard";
import LeadsPage from "./pages/LeadsPage";
import Sidebar from "./components/Sidebar";
import { UserContextProvider } from "./context/DealerProfile.jsx";
import { AllStateProviders } from "./context/globalState.jsx";
import OwnerDetails from "./pages/OwnerDetails.jsx";
import IndentRequestPage from "./pages/IndentRequestPage.jsx";
import RequestDetails from "./pages/RequestDetails.jsx";
import LeadEdit from "./pages/LeadEdit.jsx";
import LeadsFormPage from "./pages/LeadsFormPage.jsx";

function App() {
  return (
    <UserContextProvider>
    <StrictMode>
      <AllStateProviders>
      <BrowserRouter basename="/app">
        <div className="h-full w-full flex overflow-hidden">
          <Sidebar />

          <div className="flex-1 h-screen overflow-x-hidden pl-4 box-border rounded-tl-[0px] bg-[#F1F5F9]">
            <Routes>
              <Route path="/" element={<Navigate to="/home" />} />
              <Route path="/index.html" element={<Navigate to="/home" />} />
              <Route path="/home" element={<Dashboard />} />
              <Route path="/tickets" element={<LeadsPage />} />
              <Route path="/ticket-details/:id" element={<OwnerDetails />} />
              <Route path="/indent-request" element={<IndentRequestPage />} />
              <Route path="/request-details/:id" element={<RequestDetails />} />
              <Route path="/edit-request/:id" element={<LeadEdit />} />
              <Route path="/create-ticket" element={<LeadsFormPage />} />
              
            </Routes>
          </div>
        </div>
      </BrowserRouter>
      </AllStateProviders>
    </StrictMode>
    </UserContextProvider>
  );
}


createRoot(document.getElementById("root")).render(<App />);
